exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-button[data-v-d272c650] {\n    min-width: 40px;\n}\n.icons-container[data-v-d272c650] {\n    max-width: 100%;\n    overflow-x: auto;\n}\n", ""]);

// exports
